/* eslint-disable */
// @ts-nocheck
import type { EntityUserRelation, Org, OrgReducer } from '../../common/types/orgTypes';
import { INIT_STATE } from '../../common/reducers/OrgReducer';
import { createSelector } from 'reselect';
import { APP_VIEW, ORG_VIEW, AGENCY_VIEW } from '../../common/support/viewConstants';

export function getState(state: any): OrgReducer {
  return (state && state.org) || INIT_STATE;
}

export const getAppsAndOrg: (state: any) => Array<EntityUserRelation> | null | undefined = createSelector(
  getState,
  (state) => (state && state.appsAndOrgs) || undefined
);
export const getCurrentOrg: (state: any) => Org | null | undefined = createSelector(
  getState,
  (state) => (state && state.currentOrg) || undefined
);
export const getCurrentOrgName: (state: any) => string | null | undefined = createSelector(
  getCurrentOrg,
  (currentOrg) => (currentOrg && currentOrg.name) || undefined
);
export const isUserOnAgencyView: (state: any) => boolean = createSelector(getState, (state) => {
  if (!state) {
    return false;
  }

  if (state.userOnAgencyView == 1) {
    return true;
  }

  if (state.userOnAgencyView == 0) {
    return false;
  }

  return Boolean(state.userOnAgencyView);
});
export const selectAgency: (state: any) => EntityUserRelation | null | undefined = createSelector(
  getAppsAndOrg,
  (appsAndOrgs) => {
    return appsAndOrgs && appsAndOrgs.find((org) => org.organization_type === AGENCY_VIEW);
  }
);
export const isUserOnOrgView: (state: any) => boolean = createSelector(getState, (state) => {
  if (!state) {
    return false;
  }

  if (state.userOnOrgView == 1) {
    return true;
  }

  if (state.userOnOrgView == 0) {
    return false;
  }

  return Boolean(state.userOnOrgView);
});
export const isUserOnAppViewOfAppWithinOrg: (state: any) => boolean = createSelector(
  getState,
  (org) => !org.userOnOrgView && !!org.currentOrg
);
export const isUserOnAppView = createSelector<any, boolean, boolean, boolean>(
  isUserOnAgencyView,
  isUserOnOrgView,
  (userOnAgencyView, userOnOrgView) => {
    if (userOnAgencyView) {
      return false;
    }

    if (userOnOrgView) {
      return false;
    }

    return true;
  }
);
export const areAppsAndOrg: (state: any) => Boolean = createSelector(getAppsAndOrg, (state) => {
  return Boolean(state);
});
export const isCurrentOrg: (state: any) => Boolean = createSelector(getCurrentOrg, (state) => Boolean(state));
export const isOrgInitializationComplete: (state: any) => Boolean = createSelector(getState, (state) =>
  Boolean(state.initializationComplete && state.initializationComplete == 1)
);
export const areAppsAndOrgLoaded: (state: any) => Boolean = createSelector(getAppsAndOrg, (state) => {
  return Boolean(state);
});
export const isCurrentOrgLoaded: (state: any) => Boolean = createSelector(getCurrentOrg, (state) => Boolean(state));
export const selectViewForEntity: (state: any) => string = createSelector(getState, (org) => {
  if (org.userOnOrgView) {
    return ORG_VIEW;
  } else {
    return APP_VIEW;
  }
});
export const selectAgencyId: (state: any) => string | null | undefined = createSelector(
  getState,
  (state) => state && state.agency_id
);

export const getDiscoOrgs: (state: any) => string | null | undefined = createSelector(
  getAppsAndOrg,
  (state) =>
    state &&
    state.filter((appsAndOrg) => {
      if (appsAndOrg?.organization_type == 'disco_advertiser') {
        return appsAndOrg;
      }
    })
);
